<template>
  <div class="audio-playing-btn-component"
       v-show="show"
       @click="handleClick"
  >
    <ym-img class="img"
            :src="src"
            alt="播放图片"
    />
  </div>
</template>

<script>
  export default {
    name: 'AudioPlayingBtn',
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      status: {
        type: String,
        required: true,
        default: 'normal',
        validator(val) {
          return [
            'normal',
            'playing',
          ].includes(val);
        },
      },
    },
    computed: {
      src() {
        const status = {
          normal: 'bar-btn-normal.png',
          playing: 'bar-btn-playing.gif',
        };
        // eslint-disable-next-line  import/no-dynamic-require, global-require
        return require(`@/assets/img/audio/${status[this.status]}`);
      },
    },
    methods: {
      handleClick() {
        this.$emit('click');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @playing-btn-size: 40px;
  .audio-playing-btn-component {
    width: @playing-btn-size;
    height: @playing-btn-size;
    background: @color-white;
    .img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
</style>
